import React from 'react';
import ProfileLayout from 'components/ProfileLayout';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { fetchAreas } from 'data/fetchers';
import EditProfileForm from 'components/forms/EditProfileForm';
import toast from 'react-hot-toast';

export async function getStaticProps() {
    const queryClient = new QueryClient();
    await queryClient.prefetchQuery('areas', () => fetchAreas());

    return {
        props: {
            dehydratedState: dehydrate(queryClient),
            revalidate: 60 * 60 * 24
        }
    };
}

const EditProfilePage = () => {
    const { data: areas } = useQuery('areas', () => fetchAreas());

    const handleSuccess = () => {
        toast.success('Profil uspešno posodobljen.');
    };

    return (
        <>
            <ProfileLayout>
                <div className="flex flex-col md:flex-row gap-4 lg:gap-16 mt-4 md:mt-0">
                    <EditProfileForm
                        onSuccess={handleSuccess}
                        municipalities={areas?.data.filter((area) => area.type.key === 'municipality')}
                    />
                </div>
            </ProfileLayout>
        </>
    );
};

export default EditProfilePage;
